module.exports = __webpack_public_path__ + "static/media/1011117.da180301.jpg";